// src/features/treasury/components/TreasuryDashboard/TreasuryReport.jsx
import React, { useState, useEffect } from 'react';
import { fetchTreasuryReport } from '../../../../api';
import StatCard from '../../../../shared/components/ui/StatCard';
import Button from '../../../../shared/components/ui/Button';
import LoadingSpinner from '../../../../shared/components/ui/LoadingSpinner';
import { formatNumber } from '../../../../shared/utils/formatters';
import styles from './TreasuryDashboard.module.css';

const TreasuryReport = () => {
    const [report, setReport] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [filters, setFilters] = useState({ start_date: '', end_date: '' });

    const loadReport = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await fetchTreasuryReport(filters);
            setReport(res.data);
        } catch (err) {
            setError('فشل في تحميل التقرير الشامل.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadReport(); },[]);

    return (
        <div>
            <div className={styles.filterBar}>
                <input type="date" name="start_date" value={filters.start_date} onChange={e => setFilters(p => ({...p, start_date: e.target.value}))} title="من" />
                <input type="date" name="end_date" value={filters.end_date} onChange={e => setFilters(p => ({...p, end_date: e.target.value}))} title="إلى" />
                <Button variant="primary" onClick={loadReport} disabled={loading}>تحديث التقرير</Button>
            </div>

            {loading && <LoadingSpinner message="جاري إعداد التقرير المحاسبي..." />}
            {error && <p className={styles.errorMsg}>{error}</p>}

            {report && !loading && (
                <>
                    <div className={styles.statsGrid}>
                        <StatCard title="الرصيد في بداية الفترة" value={report.opening_balance} color="default" decimals={0} />
                        <StatCard title="إجمالي الوارد للفترة" value={report.total_inflow} color="success" decimals={0} />
                        <StatCard title="إجمالي الصادر للفترة" value={report.total_outflow} color="danger" decimals={0} />
                        <StatCard title="الرصيد في نهاية الفترة" value={report.closing_balance} color="primary" decimals={0} />
                    </div>

                    <div className={styles.reportDetailsGrid}>
                        <div className={styles.reportCard}>
                            <h4>تفصيل الوارد (+)</h4>
                            <ul>
                                <li><span>إيداعات نقدية يدوية:</span> <strong>{formatNumber(report.total_deposits, 0)}</strong></li>
                                <li><span>دفعات الحجوزات المستلمة:</span> <strong>{formatNumber(report.total_payments, 0)}</strong></li>
                            </ul>
                        </div>
                        <div className={styles.reportCard}>
                            <h4>تفصيل الصادر (-)</h4>
                            <ul>
                                <li><span>سحوبات نقدية يدوية:</span> <strong>{formatNumber(report.total_withdrawals, 0)}</strong></li>
                                <li><span>مصاريف إجمالية:</span> <strong>{formatNumber(report.total_expenses, 0)}</strong></li>
                                <li><span>تكاليف الطباعة والتخرج:</span> <strong>{formatNumber(report.total_printing_costs, 0)}</strong></li>
                            </ul>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
export default TreasuryReport;